import type { CardId } from '@voll-intelligence/domain';

import { t } from '@web/i18n';
import { useCardDetail } from '@web/ui/core/hooks';
import { CardClaimBanner, ConversationThread } from '@web/ui/core/organisms';

export interface ConversationViewProps {
  cardId: CardId;
}

/**
 * Conversation tab — resolves the card's `conversationId` from `externalRefs`
 * and renders the shared <ConversationThread/> (messages + composer).
 */
export function ConversationView({ cardId }: Readonly<ConversationViewProps>): React.JSX.Element {
  const detailQuery = useCardDetail(cardId);
  const detail = detailQuery.data;

  const conversationId = detail?.externalRefs.find((r) => r.system === 'conversation')?.externalId;

  if (detailQuery.isLoading) {
    return (
      <div className="flex-1 overflow-auto px-5 py-6">
        <p className="text-meta text-muted-foreground">{t('card.drawer.conversation.loading')}</p>
      </div>
    );
  }

  return (
    <ConversationThread
      conversationId={conversationId}
      banner={<CardClaimBanner cardId={cardId} />}
      canReply={detail?.assignedToMe ?? false}
    />
  );
}
